import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { AsHttpParams } from '../models/AsHttpParams.model';

@Injectable({
  providedIn: 'root'
})
export class RecipesService {

  private URL_SERVICES: string = environment.rootServicesUrl;

  constructor(
    private http: HttpClient
  ) { }

  public async getRecipes(params: AsHttpParams): Promise<any> {
    try {
      return await this.http.get(`${this.URL_SERVICES}/recipes`, { params }).toPromise();
    } catch (error) {
      return error;
    }
  }

  public async getCategories(): Promise<any> {
    return this.http.get(`${this.URL_SERVICES}/recipes/categories?page=0`).toPromise();
  }

  public async getRecipeById(id: string): Promise<any> {
    return this.http.get(`${this.URL_SERVICES}/recipes/${id}`).toPromise();
  }
}
